
























import Vue from 'vue';

interface ShortCut {
  text: string;
  value: () => Date[];
}

function getValue(timestamp: number): Date[] {
  const end = new Date();
  const start = new Date();
  start.setTime(start.getTime() - timestamp);
  return [start, end];
}

const shortcuts: ShortCut[] = [
  {
    text: '1周',
    value() {
      return getValue(3600 * 1000 * 24 * 7);
    },
  },
  {
    text: '1个月',
    value() {
      return getValue(3600 * 1000 * 24 * 30);
    },
  },
  {
    text: '3个月',
    value() {
      return getValue(3600 * 1000 * 24 * 90);
    },
  },
];

export default Vue.extend({
  props: {
    custom: Object,
  },
  mounted() {
    this.op = this.custom.greater;
  },
  data() {
    return {
      op: undefined,
      options: {
        shortcuts,
      },
    };
  },
  methods: {
    updateOp(op: number) {
      this.op = op;
      this.$emit('updateGreater', op);
    },
    updateDate(date: string) {
      this.$emit('updateDate', date);
    },
  },
});
